export default {"src":"/_next/static/media/ic_kosik2.33039fac.svg","height":20,"width":20};